// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.

export const ADD_DEVICE_REGIONS_ACTIVE = "ADD_DEVICE_REGIONS_ACTIVE";
export const ADD_DEVICE_REGIONS_INACTIVE = "ADD_DEVICE_REGIONS_INACTIVE";
